import React from "react";
import classnames from "classnames";
import Link from "next/link";

import { Action, Category, Label } from "constants/events";
import { useEventTracker } from "hooks/useEventTracker";

import IconSvg from "components/IconSvg";
import Image from "components/Image";

type Props = {
  name: string;
  claimed: boolean;
  tagline: string | null;
  logo: string;
  id?: number;
};

const BrandLogoHeading = ({
  name,
  claimed,
  tagline,
  logo,
  id: brandId,
}: Props) => {
  const { publishEvent } = useEventTracker();
  const showTagLine = !!tagline && claimed;
  const showBrandThumbNail = claimed && logo;
  return (
    <div
      className={classnames("flex items-center")}
      style={{ minHeight: "70px" }}
    >
      <div
        style={{ height: 70, width: 70 }}
        className={classnames(
          "flex items-center justify-center rounded flex-shrink-0 overflow-hidden",
          { "bg-leafly-white": !showBrandThumbNail }
        )}
      >
        {showBrandThumbNail ? (
          <Image
            src={logo}
            sizes={[70]}
            alt={`Logo for the brand ${name}`}
            preload
            disableLazyLoad
          />
        ) : (
          <IconSvg width="44" height="41" filePath={"brand_store.svg"} />
        )}
      </div>
      <div className="ml-lg">
        <h1 className="heading--l">{name}</h1>
        {showTagLine && <div className="text-sm">{tagline}</div>}
        {!claimed && (
          <Link
            href="https://success.leafly.com/brand-subscription"
            className="text-green underline font-bold"
            onClick={() => {
              publishEvent({
                action: Action.click,
                brandId,
                category: Category.brandInfo,
                label: Label.claimYourBrand,
              });
            }}
          >
            unclaimed brand
          </Link>
        )}
      </div>
    </div>
  );
};

export default BrandLogoHeading;
